import { Outlet } from 'react-router-dom'
import AppShell from '@components/shell/AppShell'
import StudioRunCommandPalette from '@/components/studio/StudioRunCommandPalette'

export default function Layout() {
  return (
    <>
      <StudioRunCommandPalette />
      <AppShell>
        <Outlet />
      </AppShell>
    </>
  )
}
